import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from './utils';
import type {
  RasterLayerSource,
  VectorLayerSource,
} from '@/generated/types/navigator/types.gen';

export const datasetApi = createApi({
  reducerPath: 'datasetApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    fetchDatasets: builder.query<
      (RasterLayerSource | VectorLayerSource)[],
      void
    >({
      query: () => ({
        url: `/v1/dataset/`,
      }),
    }),
  }),
});

export const { useFetchDatasetsQuery } = datasetApi;

export const resetDatasetApiState = datasetApi.util.resetApiState;
